import api from 'plugin/api';
import { API_URL } from 'types/const';

/**
 * 전송 내역 목록 조회
 * @param {Object} params 요청 데이터
 * @param {number[]} params.factoryCodeSeqList 선택한 공장
 * @param {string} params.priceYm 월
 * @return {Object} 응답 데이터
 */
async function requestExport(params) {
  return api.get(API_URL.sfms.dashboard.rawMaterial.price.export, { params });
}

/**
 * 원료 단가 목록 조회
 * @param {Object} params 요청 데이터
 * @param {number} params.factoryCodeSeq 공장
 * @param {string} params.priceYm 월
 * @return {Object} 응답 데이터
 */
async function requestStatistic(params) {
  return api.get(API_URL.sfms.dashboard.rawMaterial.price.statistic, {
    params
  });
}

/**
 * 원료 가격 추이 조회
 * @param {Object} params 요청 데이터
 * @param {string} params.startPriceYm 시작 월
 * @param {string} params.endPriceYm 끝 월
 * @param {number} params.factoryCodeSeq 공장
 * @return {Object} 응답 데이터
 */
async function requestTrend(params) {
  return api.get(API_URL.sfms.dashboard.rawMaterial.price.trend.default, {
    params
  });
}

/**
 * 원재료비 추이 조회
 * @param {Object} params 요청 데이터
 * @param {string} params.startPriceYm 시작 월
 * @param {string} params.endPriceYm 끝 월
 * @param {string} params.buCode BU
 * @param {number[]} params.factoryCodeSeqList 공장
 * @return {Object} 응답 데이터
 */
async function requestTrendStock(params) {
  return api.get(API_URL.sfms.dashboard.rawMaterial.price.trend.stock, {
    params
  });
}

export { requestExport, requestStatistic, requestTrend, requestTrendStock };
